import { registerPlugin } from '@capacitor/core';
const Toast = registerPlugin('Toast', {
    web: () => import('./web').then(m => new m.ToastWeb()),
});
export * from './definitions';
export { Toast };
//# sourceMappingURL=index.js.map